import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    margin: 'auto',
    flexDirection: 'column',
    maxWidth: theme.spacing(240),
  },

  mainContainer: {
    width: '100%',
    height: 'inherit',
    position: 'relative',
  },

  pinnedContainer: {
    position: 'fixed',
  },

  wrapper: {
    height: '100%',
  },

  contentContainer: {
    position: 'relative',

    '&.content': {
      display: 'block',
    },
  },

  main: {
    flex: '1 1',
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(7.5),
  },

  content: {
    flex: '1 1',
    display: 'flex',
    overflowY: 'auto',
    flexDirection: 'column',
  },

  outlet: {
    padding: theme.spacing(3.75),
    [theme.breakpoints.down('lg')]: {
      paddingBottom: theme.spacing(12.5),
    },
  },

  mobileOutlet: {
    padding: theme.spacing(2, 0),

    [theme.breakpoints.down('lg')]: {
      paddingBottom: theme.spacing(8),
    },
  },

  mainContent: {
    height: '100%',
  },

  scroll: {
    width: '100%',
  },
}));
